// extracted by css-extract-rspack-plugin
export default {"name":"Step_name__xMSHm","step":"Step_step__TyabZ","active":"Step_active__dEykZ","stepBox":"Step_stepBox__Q00h1","stepList":"Step_stepList__D2tIq"};